<template>
  <el-dialog width="330px" :visible='visible' :close-on-click-modal='false' :close-on-press-escape='false' @open = "open"
    :show-close='false' @close='close'>
    <template #title>
      <div class="mk-dialog-title">关联凭证</div>
    </template>
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px">
      <el-form-item label="期数">
        <accounting-period :isDaterange='false' :disabled = "true"></accounting-period>
      </el-form-item>
      <el-form-item label="凭证号" prop="voucherChief">
        <el-select v-model="ruleForm.voucherChief" placeholder="请选择凭证" size = "small" style="width: 145px;">
          <el-option v-for = "(i,index) in voucherList" :key = "index" :label="i.number" :value="i.id" ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <template #footer>
      <div style="text-align:center">
        <el-button @click="close" size="small" style="width:100px;">取消</el-button>
        <el-button @click="validInfo" size="small" style="width:100px;background:#269D7B;color:#fff">确定</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import { findVoucherChiefNumber, relevancyVoucherChief } from '@/api'
import accountingPeriod from '@/components/dialog/accountingPeriod'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    ids: {
      type: String,
      default: ""
    },
    type: { // 单据类型 1 发票 2 银行流水
      type: Number,
      default: 1
    }
  },
  components: {
    accountingPeriod
  },
  data() {
    return {
      ruleForm: {
        voucherChief: '',
      },
      voucherList: [],
      rules: {
        voucherChief: [
            { required: true, message: '请选择凭证', trigger: 'change' }
          ],
        }
    }
  },
  methods: {
    open() {
      this.ruleForm.voucherChief = ""
      this.getVouvherList()
    },
    // 关联凭证
    async handleRelevancy() {
      if(!this.ids) {
        this.$message.warning("请选择数据后再试")
        return
      }
      const params = {
        voucherChief: this.ruleForm.voucherChief,
        billIds: this.ids,
        type: this.type,
      }
      const { data } = await relevancyVoucherChief(params);
      if(data.code == 1) {
        this.$message.success(data.msg)
        this.$emit("success")
        this.close()
      }else {
        this.$message.error(data.msg)
      }
    },
    validInfo() {
      this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            this.handleRelevancy()
          } else {
            return false;
          }
        });
    },
    // 获取凭证号
    async getVouvherList() {
      const { data } = await findVoucherChiefNumber()
      this.voucherList = data.data || []
    },
    close() {
      this.$emit('close')
    }
  }

}
</script>

<style lang='less' scoped></style>



// WEBPACK FOOTER //
// src/components/common/connect-voucher.vue